import { createSlice } from '@reduxjs/toolkit';
import { graphqlApi } from '../../api'

const initialState = {
  academicPlan: "",
  academicPlanDescription: "",
  academicProgram: "",
  academicProgramDescription: "",
  admitType: "",
  assignable: null,
  countryOfCitizenship: "",
  earlyAction: false,
  firstGen: false,

  homeCountry: "",
  lowSocioeconomic: false,
  regularDecision: false,
  residency: "",
  rural: false,
  stage: "",
  termLabel: "",
  zip: "",
  
  // applicantEmployeeId: "",

  // buckeyeStudentLeadershipAcademy: "",

  // classRankPercentile: "",
  // classRankType: "",
  // classSize: "",
  // classStanding: "",
  // committeeId: "",
  // group: "",
  // groupName: "",
  // county: "",
  // dateAssigned: "",
  // dateOfBirth: "",

  // evaluationDate: "",

  // firstName: "",
  // highSchoolName: "",
  // highSchoolGPA: "",
  // highSchoolLocation: "",
  // highSchoolGraduationDate: "",

  // honors: false,
  // lastName: "",

  // middleInitial: "",
  // msp: false,

  // residency: "",
  // residencyCategory: "",

  // scholars: false,
  // siblings: "",

  // inprogressStatus: null,
  // status: "",
  // reason: ""
}

const transform = (data) => {
  let transformedData = {...data};

  // console.log("data: ", data);
  transformedData.earlyAction = data?.earlyAction === true ? "Yes" : "No"
  transformedData.regularDecision = data?.regularDecision === true ? "Yes" : "No"
  transformedData.lowSocioeconomic = data?.lowSocioeconomic === true ? "Yes" : "No"
  transformedData.firstGen = data?.firstGen ? "Yes" : "No"

  return transformedData
}

// function yesNoIfValid(b) {
//     if (![true, false].includes(b)) { return b; }
//     return b ? "Yes" : "No";
// }

const demographicsSlice = createSlice({
  name: 'applicant-detail-demographics',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      graphqlApi.endpoints.getApplicationDetails.matchFulfilled,
      (state, { payload }) => {
        if (payload?.details?.demographics) {
          let newState = {};
          for (let key in initialState) {
            newState[key] = payload?.details?.demographics[key];
          }
          // console.info("beforeTransform data:", newState);
          return transform(newState);
        }
      }
    )
  }
});

export const selectDemographicData = (state) => state.demographicsSlice

export default demographicsSlice.reducer;